import { PropertyTypes } from '@aloft/toolkit-shared';

export const PROPERTY_TYPE_CHECKBOX_ITEMS = [
  { id: 'Single Family Residence', label: 'SFR' },
  { id: 'Townhouse', label: 'TH' },
  { id: 'Lots and Land', label: 'Lot' },
  { id: 'Multifamily Property', label: 'MF' },
  { id: 'Condominium', label: 'Condo' },
  { id: 'Manufactured Home', label: 'MH' },
] as const;

export type PropertyTypeFilterValue = (typeof PROPERTY_TYPE_CHECKBOX_ITEMS)[number]['id'];

const TOOLKIT_PROPERTY_TYPE_TO_FILTER_VALUE: Partial<
  Record<PropertyTypes, PropertyTypeFilterValue>
> = {
  singleFamilyResidence: 'Single Family Residence',
  townhouse: 'Townhouse',
  lotsLand: 'Lots and Land',
  multiFamily: 'Multifamily Property',
  condominium: 'Condominium',
  manufacturedHome: 'Manufactured Home',
};

export const getPropertyTypeFilterValue = (
  propertyType?: PropertyTypes,
): PropertyTypeFilterValue | undefined =>
  propertyType ? TOOLKIT_PROPERTY_TYPE_TO_FILTER_VALUE[propertyType] : undefined;
